import React from 'react';
import WinBase from '../components/base/win-base';

const ChampionshipRulesWin = () => {
  return <WinBase sportType="general" />;
};

export default ChampionshipRulesWin;
